import React from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';

export type TooltipRow = {
  color: string;
  label: string;
  amount: string;
  opacity?: number;
};

type Props = {
  title: string;
  subtitle: string;
  rows: ReadonlyArray<TooltipRow>;
  /** Left offset in %, where to anchor the tooltip horizontally */
  leftPct?: number;
  /** How far from the top (px) */
  topPx?: number;
};

export default function CashFlowTooltip({ title, subtitle, rows, leftPct = 50, topPx = 0 }: Props) {
  return (
    <div style={{
      position: 'absolute',
      left: leftPct + '%',
      transform: 'translateX(-50%)',
      bottom: 'calc(100% + 8px)',
      top: topPx,
      background: C.ink,
      color: '#fff',
      borderRadius: 8,
      padding: '10px 12px',
      fontSize: 11.5,
      minWidth: 200,
      boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
      zIndex: 10,
      pointerEvents: 'none',
      fontFamily: F.family,
    }}>
      <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 2 }}>{title}</div>
      <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 10.5, marginBottom: 8, whiteSpace: 'nowrap' }}>
        {subtitle}
      </div>
      {rows.map((r, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '3px 0', gap: 12 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, whiteSpace: 'nowrap' }}>
            <span style={{ width: 9, height: 9, borderRadius: '50%', background: r.color, opacity: r.opacity ?? 1 }} />
            {r.label}
          </span>
          <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>{r.amount}</span>
        </div>
      ))}

      <div style={{
        position: 'absolute', left: '50%', bottom: -5,
        transform: 'translateX(-50%) rotate(45deg)',
        width: 10, height: 10, background: C.ink,
      }} />
    </div>
  );
}
